const yes_no_list = [
  { key: 1, value: true, text: "tak" },
  { key: 2, value: false, text: "nie" }
];

export default  yes_no_list; 